var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-col',{attrs:{"cols":"12","md":"3","tag":"li"}},[(_vm.isLoading)?_c('Loading'):_c('b-col',{on:{"click":_vm.selectL3}},[_vm._v(_vm._s(_vm.workingCategory.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }